import { AiFieldProposal, ResolveAiFieldProposalInput } from "src/generated/graphqlTypes";
import { ObjectConfig } from "src/utils/formState";

export type AiFieldProposalFormValue = ResolveAiFieldProposalInput & Pick<AiFieldProposal, "fieldName" | "fieldValue">;

/** Nest as `fieldProposals: { type: "list", update: "incremental", config: aiFieldProposalConfig }` on a form that reviews AI field proposals. `fieldName`/`fieldValue` are server-owned; `status` is what Accept/Reject writes. */
export const aiFieldProposalConfig: ObjectConfig<AiFieldProposalFormValue> = {
  id: { type: "value" },
  fieldName: { type: "value", readOnly: true },
  fieldValue: { type: "value", readOnly: true },
  status: { type: "value" },
};
